export default __webpack_public_path__ + "static/media/jo.bc0611db.jpg";